import 'css-chunksrc/client/pages/costProfilesPage/resource/styles.scss';export default {
  "resource": "_resource_15gnd_1",
  "contextualMenu": "_contextualMenu_15gnd_8",
  "user": "_user_15gnd_27",
  "avatar": "_avatar_15gnd_37",
  "name": "_name_15gnd_49",
  "title": "_title_15gnd_54",
  "costProfile": "_costProfile_15gnd_60",
  "affiliation": "_affiliation_15gnd_69",
  "status": "_status_15gnd_78",
  "icon": "_icon_15gnd_84",
  "readOnly": "_readOnly_15gnd_88"
};